<template>
    <oc-form :nested="true" :model="form">
        <template v-if="! schema.rules">
            <div class="and-or-template row and-or-first">
                <div class="col">
                    <div class="and-or-top row">
                        <div class="col-7 btn-and-or">
                            <oc-button @click.prevent="addFirstGroup" text="+ ( group )" size="small" class="btn-rule" />
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <oc-query-builder-group
            v-else
            :isFirst="true"
            :group="schema"
            :lock="lockFirstGroup"
            @delete-group="deleteGroup"
        >
            <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="data">
                <slot :name="slot" v-bind="data"></slot>
            </template>
        </oc-query-builder-group>
    </oc-form>
</template>

<script>
import Form from '@/helpers/Form'
import Group from '@/components/ui/filter/QueryBuilder/Group.vue'
import SchemaMixin from '@/components/ui/filter/QueryBuilder/helpers/SchemaMixin'

export default {
    name: 'oc-query-builder',
    mixins: [SchemaMixin],
    components: {
        [Group.name]: Group
    },
    props: {
        /**
         * Form instance or plain object (JSON structure)
         */
        model: {
            type: Object,
            required: true
        },
        /**
         * Allow deletion of the last remaining group
         */
        lockFirstGroup: {
            type: Boolean,
            default: true
        },
        /**
         * The Form model key that holds the schema
         */
        modelSchemaKey: {
            type: [String, Number],
            default: null
        },
        /**
         * [{value: 'start_date', text: 'From Date'}, ... ]
         */
        keys: {
            type: [Array, Object],
            required: true
        },
        /**
         * [{value: '!=', text: 'is not'}, ... ]
         */
        operators: {
            type: Array,
            default: () => [
                { value: '==', text: 'is' },
                { value: '!=', text: 'is not' },
                { value: '>', text: 'is greater than' },
                { value: '>=', text: 'is greater or equal to' },
                { value: '<', text: 'is less than' },
                { value: '<=', text: 'is less or equal to' },
                { value: 'match', text: 'matches' },
                { value: 'contain', text: 'contains' },
                { value: 'in', text: 'is in list' },
                { value: '!in', text: 'is not in list' }
            ]
        },
        /**
         * {
         *     keyAttrs: {},
         *     keyEvents: {},
         *     operatorAttrs: {},
         *     operatorEvents: {},
         *     valueAttrs: {},
         *     valueEvents: {}
         * }
         */
        options: {
            type: Object,
            default: () => ({})
        }
    },
    provide() {
        let params = {}

        Object.defineProperty(params, 'keys', {
            enumerable: true,
            get: () => this.keys
        })

        Object.defineProperty(params, 'operators', {
            enumerable: true,
            get: () => this.operators
        })

        Object.defineProperty(params, 'options', {
            enumerable: true,
            get: () => this.options
        })

        Object.defineProperty(params, 'form', {
            enumerable: true,
            get: () => this.form
        })

        Object.defineProperty(params, 'modelSchemaKey', {
            enumerable: true,
            get: () => this.modelSchemaKey
        })

        return {
            // we provide object in order to have vue reactivity
            params,
            $component: this
        }
    },
    data () {
        let form = this.model

        if( ! (form instanceof Form) ) {
            form = new Form(form, ($, rules) => rules(
                $(/(key|op|value)/).required()
            ))
        }

        return {
            form
        }
    },
    created() {
        this.addFirstGroup()
    },
    computed: {
        schema() {
            if( this.modelSchemaKey !== null ) {
                return this.form.getDeep(this.modelSchemaKey)
            }

            return this.form
        }
    },
    methods: {
        addFirstGroup() {
            if( this.schema.logic_op === undefined ) {
                let schema = this.getSchema()

                if( this.modelSchemaKey !== null ) {
                    this.form.setDeep(this.modelSchemaKey, schema)
                } else {
                    this.form.load(schema)
                }

            }
        },
        deleteGroup() {
            if( this.modelSchemaKey !== null ) {
                this.form.setDeep(this.modelSchemaKey, {})
            } else {
                this.form.clear()
            }
        },
        getData() {
            return this.form.getData()
        }
    }
}
</script>
<style scoped>
/deep/ .and-or-template {
    padding: 8px;
    position: relative;
    border-radius: 3px;
    border: 1px solid #6c666e;
    border-top: 3px solid #d2d6de;
    margin-bottom: 20px;
    /* width: 100%; */
    box-shadow: 0 1px 1px rgba(0,0,0,0.1);
    border-top-color: #6c666e;
    background-color: rgba(255, 255, 255, 0.9);
}

/deep/ .and-or-template:before,
/deep/ .and-or-template:after {
    content: '';
    position: absolute;
    left: -17px;
    width: 16px;
    height: calc(50% + 18px);
    /* border-color: #c0c5e2; */
    border-color: #6c666e;
    border-style: solid;
}

/deep/ .and-or-template:before {
    top: -18px;
    border-width: 0 0 2px 2px;
}

/deep/ .and-or-template:after {
    top: 50%;
    border-width: 0 0 0 2px;
}

/deep/ .and-or-first:before,
/deep/ .and-or-first:after,
/deep/ .and-or-template:last-child:after {
    border: none;
}

/deep/ .and-or-top,
/deep/ .btn-and-or {
    padding: 0;
}

/deep/ .btn-and-or button {
    margin-left: 4px;
}

/deep/ .and-or-offset {
    margin-left: 30px;
}

/deep/ .box.box-purple {
    border-top-color: #6c666e;
}

/deep/ .box.box-solid.box-purple {
    border: 1px solid #6c666e;
}

/deep/ .box.box-solid.box-purple>.box-header {
    color: #fff;
    background-color: #6c666e;
}

/deep/ .skin-purple .main-header .navbar {
    background-color: #6c666e;
}

/deep/ .btn-rule-outline {
    color: #6c666e;
    background-color: transparent;
    background-image: none;
    border-color: #6c666e;
}

/deep/ .btn-rule,
/deep/ .btn-rule-outline:hover,
/deep/ .btn-rule-outline:active,
/deep/ .btn-rule-outline:focus,
/deep/ .btn-rule-outline-focus {
    color: #fff;
    background-color: #6c666e;
    border-color: #6c666e;
}

/deep/ .btn-rule:hover,
/deep/ .btn-rule:active,
/deep/ .btn-rule:focus {
    color: #fff;
    background-color: #000000;
    border-color: #000000;
}

/deep/ .btn-radius {
    border-radius: 11px;
}

/deep/ .btn-rule-round {
    padding: 0;
    width: 20px;
    height: 20px;
}
</style>
